import React, { useRef } from "react";
import { Table, Input, Button } from "antd";
import { useSelector } from "react-redux";
import { InfoCircleOutlined } from "@ant-design/icons";
import "./index.css";

const TablesEfficiencyTable = () => {
  const { tablesEfficiencyData, loading } = useSelector(
    (state) => state.tablesEfficiencyReducer
  );
  const searchInput = useRef(null);

  const dataSource = tablesEfficiencyData.map((item, idx) => ({
    ...item,
    revenuePerMinute:
      item.totalBusyTime > 0
        ? (item.totalRevenue / item.totalBusyTime).toFixed(2)
        : "0.00",
    key: idx,
  }));

  const columns = [
    {
      title: "№ Маса",
      dataIndex: "tableName",
      key: "tableName",
      align: "center",
      filters: [
        ...Array.from(new Set(dataSource.map((item) => item.tableName))).map(
          (name) => ({
            text: name,
            value: name,
          })
        ),
      ],
      onFilter: (value, record) => record.tableName === value,
      sorter: (a, b) => a.tableName.localeCompare(b.tableName),
    },
    {
      title: "Брой сметки",
      dataIndex: "billCount",
      key: "billCount",
      align: "center",
      sorter: (a, b) => a.billCount - b.billCount,
    },
    {
      title: "Общо време (мин)",
      dataIndex: "totalBusyTime",
      key: "totalBusyTime",
      align: "center",
      sorter: (a, b) => a.totalBusyTime - b.totalBusyTime,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="По-голямо от:"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="tables-efficiency-columns-filter-input"
            type="number"
            min={0}
          />
          <div className="tables-efficiency-columns-filter-container">
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              id="tables-efficiency-columns-filter-action-btn"
            >
              Филтрирай
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              id="tables-efficiency-columns-filter-reset-btn"
            >
              Изчисти
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) =>
        parseFloat(record.totalBusyTime) > parseFloat(value),
      filterIcon: (filtered) => (
        <span
          role="img"
          aria-label="search"
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        >
          &#128269;
        </span>
      ),
    },
    {
      title: "Среден престой (мин)",
      dataIndex: "avgBusyTime",
      key: "avgBusyTime",
      align: "center",
      sorter: (a, b) => a.avgBusyTime - b.avgBusyTime,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="По-голямо от:"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="tables-efficiency-columns-filter-input"
            type="number"
            min={0}
          />
          <div className="tables-efficiency-columns-filter-container">
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              id="tables-efficiency-columns-filter-action-btn"
            >
              Филтрирай
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              id="tables-efficiency-columns-filter-reset-btn"
            >
              Изчисти
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) =>
        parseFloat(record.avgBusyTime) > parseFloat(value),
      filterIcon: (filtered) => (
        <span
          role="img"
          aria-label="search"
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        >
          &#128269;
        </span>
      ),
    },
    {
      title: "Общо приход (€)",
      dataIndex: "totalRevenue",
      key: "totalRevenue",
      align: "center",
      render: (val) => Number(val).toFixed(2),
      sorter: (a, b) => a.totalRevenue - b.totalRevenue,
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="По-голямо от:"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="tables-efficiency-columns-filter-input"
            type="number"
            min={0}
          />
          <div className="tables-efficiency-columns-filter-container">
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              id="tables-efficiency-columns-filter-action-btn"
            >
              Филтрирай
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              id="tables-efficiency-columns-filter-reset-btn"
            >
              Изчисти
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) =>
        parseFloat(record.totalRevenue) > parseFloat(value),
      filterIcon: (filtered) => (
        <span
          role="img"
          aria-label="search"
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        >
          &#128269;
        </span>
      ),
    },
    {
      title: "Приход/минута (€)",
      dataIndex: "revenuePerMinute",
      key: "revenuePerMinute",
      align: "center",
      sorter: (a, b) =>
        parseFloat(a.revenuePerMinute) - parseFloat(b.revenuePerMinute),
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchInput}
            placeholder="По-голямо от:"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            className="tables-efficiency-columns-filter-input"
            type="number"
            min={0}
          />
          <div className="tables-efficiency-columns-filter-container">
            <Button
              type="primary"
              onClick={() => confirm()}
              size="small"
              id="tables-efficiency-columns-filter-action-btn"
            >
              Филтрирай
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
              id="tables-efficiency-columns-filter-reset-btn"
            >
              Изчисти
            </Button>
          </div>
        </div>
      ),
      onFilter: (value, record) =>
        parseFloat(record.revenuePerMinute) > parseFloat(value),
      filterIcon: (filtered) => (
        <span
          role="img"
          aria-label="search"
          style={{
            color: filtered ? "#1890ff" : undefined,
          }}
        >
          &#128269;
        </span>
      ),
    },
  ];

  // Изчисления за стойностите
  const uniqueTablesCount = new Set(
    tablesEfficiencyData.map((item) => item.tableName)
  ).size;
  const totalBills = tablesEfficiencyData.reduce(
    (sum, item) => sum + item.billCount,
    0
  );

  const totalRevenue = tablesEfficiencyData.reduce(
    (sum, item) => sum + Number(item.totalRevenue),
    0
  );

  // Извлечи всички стойности на revenuePerMinute като числа
  const revenuePerMinuteArr = dataSource
    .map((item) => parseFloat(item.revenuePerMinute))
    .filter((val) => !isNaN(val))
    .sort((a, b) => a - b);

  const tenPercentIndex = Math.floor(revenuePerMinuteArr.length * 0.1);
  const lowThreshold =
    revenuePerMinuteArr[tenPercentIndex] ?? revenuePerMinuteArr[0];
  const highThreshold =
    revenuePerMinuteArr[revenuePerMinuteArr.length - tenPercentIndex - 1] ??
    revenuePerMinuteArr[revenuePerMinuteArr.length - 1];

  return (
    <div className="tables-efficiency-table-container">
      <div className="tables-efficiency-table-header">
        {/* Легенда в ляво */}
        <div>
          <div className="tables-efficiency-info-text">
            <div className="tables-efficiency-info-block">
              <div>
                <b>Обяд:</b> 09:00 - 16:00
              </div>
              <div>
                <b>Вечер:</b> 16:00 - 23:59
              </div>
            </div>
          </div>
          <div className="tables-efficiency-legend">
            <span className="tables-efficiency-legend-item">
              <span className="tables-efficiency-legend-dot-green"></span>
              <span className="tables-efficiency-legend-label">
                Топ 10% по ефективност
              </span>
            </span>
            <span className="tables-efficiency-legend-item">
              <span className="tables-efficiency-legend-dot-red"></span>
              <span className="tables-efficiency-legend-label">
                Най-ниски 10% по ефективност
              </span>
            </span>
          </div>
        </div>
        {/* Статистиката вдясно */}
        <div>
          <div className="tables-efficiency-table-title">
            <InfoCircleOutlined /> <span>Брой маси:</span>{" "}
            <b>{uniqueTablesCount}</b>
          </div>
          <div className="tables-efficiency-table-title">
            <InfoCircleOutlined /> <span>Брой сметки:</span> <b>{totalBills}</b>
          </div>
          <div className="tables-efficiency-table-title">
            <InfoCircleOutlined /> <span>Общ приход (€):</span>{" "}
            <b>{totalRevenue.toFixed(2)}</b>
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        pagination={false}
        size="middle"
        className="tables-efficiency-table"
        rowClassName={(record) => {
          const value = parseFloat(record.revenuePerMinute);
          if (isNaN(value)) return "";
          if (value <= lowThreshold)
            return "tables-efficiency-table-row-low-revenue";
          if (value >= highThreshold)
            return "tables-efficiency-table-row-high-revenue";
          return "";
        }}
      />
    </div>
  );
};

export default TablesEfficiencyTable;
